<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import customSelect from "../../../../components/custom-select.vue";

import { getFundingData, getFundingRankData } from '@/api/user'

/**
 * Starter component
 */
export default {
  page: {
    title: "资金费率",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader},
  data() {
    return {
      title: "资金费率",
      items: [
        {
          text: "Utility",
          href: "/"
        },
        {
          text: "Starter Page",
          active: true
        }
      ],
      fundingChart_: null,
      fundingsymboldata: [],
      fundingsymboldate: [],
      option: {
        backgroundColor: '#2A3042',
        title: {
          text: '',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          bottom: 90
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: {
          data: [],
          silent: false,
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          splitArea: {
            show: false
          }
        },
        series: [
          {
            type: 'bar',
            data: [],
            // Set `large` for large data amount
            large: true
          }
        ]
      },
      fundingCumRetChart_: null,
      fundingCumRet: [],
      cumRetoption: {
        backgroundColor: '#2A3042',
        title: {
          text: '',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          bottom: 90
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: {
          data: [],
          silent: false,
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          splitArea: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            data: [],
            // Set `large` for large data amount
            large: true
          }
        ]
      },
      fundinRankFields: [
        {
          key: "symbol",
          sortable: false
        },
        {
          key: "exchange",
          sortable: false
        },
        {
          key: "0day",
          sortable: true
        },
        {
          key: "1day",
          sortable: true
        },
        {
          key: "3day",
          sortable: true
        },
        {
          key: "7day",
          sortable: true
        },
        {
          key: "30day",
          sortable: true
        },
        {
          key: "volume",
          sortable: true
        },
        {
          key: "open_interest",
          sortable: true
        },
      ],
      fundinRankData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 200,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "30day",
      sortDesc: false,
      exchange_list: [],
      exchange: "binance_usdt",
      exchange_options: [],
      selected_exchange: "binance_usdt"
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
        return this.fundinRankData.length;
    },
  },
  methods: {
    onResize(e) {
      this.fundingChart_ = this.$echarts.init(document.getElementById('fundingChart'),'dark')
      this.fundingChart_.resize()

      this.fundingCumRetChart_ = this.$echarts.init(document.getElementById('fundingCumRetChart'),'dark')
      this.fundingCumRetChart_.resize()
    },
    selectExchange() {
      console.log("select exchange!")
    },
    searchExchange() {
      console.log('exchange: ', this.exchange)
      getFundingRankData(this.exchange).then((res) => {
      this.fundinRankData = res[0]
        }).catch((error) => {
            console.log(error)
      })
    },
    chooseExchange() {
      console.log('exchange: ', this.selected_exchange)
      getFundingRankData(this.selected_exchange).then((res) => {
      this.fundinRankData = res[0]
        }).catch((error) => {
            console.log(error)
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    RowClickHandler(record, index) {
      console.log(record.symbol)
      this.updatefunding(record.symbol)
    },
    updatefunding(symbol){
      var that = this

      that.fundingChart_ = that.$echarts.init(document.getElementById('fundingChart'),'dark')
      that.fundingCumRetChart_ = that.$echarts.init(document.getElementById('fundingCumRetChart'),'dark')

      getFundingData(symbol, this.selected_exchange).then((res) => {
        console.log(res)

        that.fundingsymboldata = []
        that.fundingsymboldate = []

        that.fundingCumRet = []

        let cumret = 0.0

        for (let i = 0; i < res.length; ++i) {
          that.fundingsymboldata.push(parseFloat(res[i]['fundingrate']))
          that.fundingsymboldate.push(res[i]['time'])

          cumret = cumret + parseFloat(res[i]['fundingrate'])
          that.fundingCumRet.push(cumret)
        }

        console.log("fundingCumRet")
        console.log(that.fundingCumRet)

        that.option.xAxis.data = that.fundingsymboldate
        that.option.series[0].data = that.fundingsymboldata
        that.option.title.text = symbol

        that.fundingChart_.setOption(that.option)

        that.cumRetoption.xAxis.data = that.fundingsymboldate
        that.cumRetoption.series[0].data = that.fundingCumRet
        that.cumRetoption.title.text = symbol

        that.fundingCumRetChart_.setOption(that.cumRetoption)
      }).catch((error) => {
          console.log(error)
      })
    }
  },
  mounted() {
    var that = this

    getFundingRankData().then((res) => {
      that.fundinRankData = res[0]
      this.exchange_list = res[1]
      for (var i=0;i<res[1].length;i++) {
        this.exchange_options.push({value: res[1][i]['label'], text: res[1][i]['value']})
      }
      console.log('fundinRankData: ', this.fundinRankData)
      that.$forceUpdate()
    }).catch((error) => {
        console.log(error)
    })

    this.updatefunding("BTCUSD_PERP")

    getFundingRankData(this.selected_exchange).then((res) => {
      this.fundinRankData = res[0]
      }).catch((error) => {
        console.log(error)
    })

    // that.fundingChart_ = that.$echarts.init(document.getElementById('fundingChart'),'dark')
    // that.fundingCumRetChart_ = that.$echarts.init(document.getElementById('fundingCumRetChart'),'dark')

    // getFundingData("BTCUSD_PERP").then((res) => {
    //   console.log(res)

    //   that.fundingsymboldata = []
    //   that.fundingsymboldate = []

    //   that.fundingCumRet = []

    //   let cumret = 0.0

    //   for (let i = 0; i < res.length; ++i) {
    //     that.fundingsymboldata.push(parseFloat(res[i]['fundingrate']))
    //     that.fundingsymboldate.push(res[i]['time'])

    //     cumret = cumret + parseFloat(res[i]['fundingrate'])
    //     that.fundingCumRet.push(cumret)
    //   }

    //   console.log("fundingCumRet")
    //   console.log(that.fundingCumRet)

    //   that.option.xAxis.data = that.fundingsymboldate
    //   that.option.series[0].data = that.fundingsymboldata
    //   that.option.title.text = "BTCUSD_PERP"

    //   that.fundingChart_.setOption(that.option)

    //   that.cumRetoption.xAxis.data = that.fundingsymboldate
    //   that.cumRetoption.series[0].data = that.fundingCumRet
    //   that.cumRetoption.title.text = "BTCUSD_PERP"

    //   that.fundingCumRetChart_.setOption(that.cumRetoption)


    // }).catch((error) => {
    //     console.log(error)
    // })
  }
};
</script>
<template>
  <Layout>
    <PageHeader
      :title="title"
    />
    <div class="row" v-resize @resize="onResize">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
            历史数据
            </h4>
            <div id="fundingChart" style="height:400px;"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
            累计收益
            </h4>
            <div id="fundingCumRetChart" style="height:400px;"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- <customSelect v-model="exchange" :list="exchange_list" placeholder="请输入交易所" @searchChange="searchExchange" is-search></customSelect> -->
    
    <!-- // 常用用法
    <customSelect v-model="dataForm.gradeId" :list="gradeList"></customSelect> -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              资金费率排名
            </h4>
            <b-tabs
              content-class="mt-3"
              nav-class="nav-tabs-custom"
            >
              <b-tab
                title="All"
                active
              >
                <div class="row mt-4">
                  <!-- <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        />&nbsp;entries
                      </label>
                    </div>
                  </div> -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_length"
                      class="dataTables_length"
                    >
                      <label class="d-inline-flex align-items-center">
                        Exchange&nbsp;
                        <b-form-select
                          v-model="selected_exchange"
                          :options="exchange_options"
                          @change="chooseExchange"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                          v-model="filter"
                          type="search"
                          placeholder="Search..."
                          class="form-control form-control-sm ml-2"
                        />
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive table-hover mb-0">
                  <b-table
                    :items="fundinRankData"
                    :fields="fundinRankFields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                    @row-clicked="RowClickHandler"
                  />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        />
                      </ul>
                    </div>
                  </div>
                </div>
              </b-tab>
              <!-- <b-tab title="Buy" disabled> </b-tab>
                        <b-tab title="Sell" disabled> </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>